<template>
  <v-dialog v-model="facilityInfo" width="1000">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        :color="type === 'avail' ? 'green' : 'grey'"
        :disabled="type === 'avail' ? false : true"
        @click="
          () => {
            if (type === 'avail') {
              facilityInfo = true;
              $emit('handleSelect', facility);
            }
          }
        "
        v-bind="attrs"
        v-on="on"
      >
        {{ facility && facility !== "" ? facilityName : "" }}
      </v-btn>
      <v-icon
        :id="facility"
        style="cursor: pointer;"
        class="ml-2"
        @click="
          () => {
            facilityInfo = true;
            $emit('modalPop', facility);
          }
        "
        >info_outline</v-icon
      >
    </template>

    <v-card>
      <v-card-title>
        <h3 class="pb-1 mb-0">
          {{ facility.title }} Information
        </h3></v-card-title
      >
      <!-- Block Booking Available -->
      <v-row class="w-100 bespoke-margin">
        <v-col :cols="mobile ? '12' : '3'">
          <b>Block Booking Available?:</b>
        </v-col>
        <v-col>
          <p>{{ facility.blockBookingAvailable ? "Yes" : "No" }}</p>
        </v-col>
      </v-row>
      <!-- Sport Options -->
      <v-row class="w-100 bespoke-margin">
        <v-col :cols="mobile ? '12' : '3'">
          <b>Facility Sport Options:</b>
        </v-col>
        <v-col>
          <span
            v-for="sport in facility.facilitySportOptions"
            :key="sport"
            class="p-0 m-0"
          >
            {{ sport }}
          </span>
        </v-col>
      </v-row>
      <!-- Weather Type -->
      <v-row class="w-100 bespoke-margin">
        <v-col :cols="mobile ? '12' : '3'">
          <b>Weather Type:</b>
        </v-col>
        <v-col>
          <p>{{ facility.facilityWeatherType }}</p>
        </v-col>
      </v-row>
      <!-- Description -->
      <v-row class="w-100 bespoke-margin">
        <v-col :cols="mobile ? '12' : '3'">
          <b>Description:</b>
        </v-col>
        <v-col>
          <p v-html="facility.description"></p>
        </v-col>
      </v-row>
      <!-- Location -->
      <v-row class="w-100 bespoke-margin">
        <v-col :cols="mobile ? '12' : '3'">
          <b>Location:</b>
        </v-col>
        <v-col>
          <p v-html="facility.location"></p>
        </v-col>
      </v-row>
      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="facilityInfo = false">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "FacilityInfo",
  props: {
    facility: {
      type: Object,
      required: true
    },
    facilityName: {
      type: String
    },
    type: {
      type: String
    }
  },
  data() {
    return {
      mobile: window.innerWidth <= 1200,
      facilityInfo: false
    };
  },
  methods: {
    showModal() {
      this.$refs["dialog-ref"].show();
    },
    hideModal() {
      this.$refs["dialog-ref"].hide();
    }
  },
  created() {
    addEventListener("resize", () => {
      this.mobile = innerWidth <= 1200;
    });
  }
};
</script>
<style>
.bespoke-margin {
  margin: 15px !important;
}
</style>
